import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from "@/pages/HomePage";
import ServicesPage from "@/pages/ServicesPage";
import ConsultationPage from "@/pages/ConsultationPage";
import ProductionPage from "@/pages/ProductionPage";
import PortfolioPage from "@/pages/PortfolioPage";
import InquiryPage from "@/pages/InquiryPage";
import AdminPage from "@/pages/AdminPage";
import CMSPage from "@/pages/CMSPage";
import PaymentSuccessPage from "@/pages/PaymentSuccessPage";
import Navigation from "@/components/Navigation";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Navigation />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/consultation" element={<ConsultationPage />} />
          <Route path="/production" element={<ProductionPage />} />
          <Route path="/portfolio" element={<PortfolioPage />} />
          <Route path="/inquiry" element={<InquiryPage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/cms" element={<CMSPage />} />
          <Route path="/payment-success" element={<PaymentSuccessPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;